import React from 'react';
import {
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';

import walletBenefit from 'assets/images/home/phone_bitcoin.png';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '120px 0px ',
    marginBottom: 50,
    [theme.breakpoints.down('sm')]: {
      padding: '60px 0px ',
    },
  },
  overlay: {
    width: '100%',
    textAlign: 'center',
    color: '#fff',
  },

  whitePaper: {
    textAlign: 'center',
  },
  newWallet: {
    width: 220,
    height: 50,
    backgroundColor: '#5B59A9',
    color: '#fff',
    marginTop: 40,
    fontWeight: 'bold',
    fontSize: 18,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#5B59A9',
    },
    [theme.breakpoints.down('xs')]: {
      width: 250,
    },
  },

  accessWallet: {
    width: 220,
    height: 50,
    backgroundColor: '#6D6D6D',
    color: '#fff',
    marginTop: 40,
    fontWeight: 'bold',
    fontSize: 18,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#6D6D6D',
    },
    [theme.breakpoints.down('xs')]: {
      width: 250,
    },
  },
  walletBenefit: {
    maxWidth: '80%',
    [theme.breakpoints.down('sm')]: {
      marginTop: 100,
    },
  },
}));

export default function WalletIntro() {
  const classes = useStyles();
  const history = useHistory();
  const {t} = useTranslation();

  return (
    <React.Fragment>
      <Container maxWidth="md" className={classes.root}>
        <Grid container>
          <Grid item md={5} xs={12}>
            <Typography
              variant="h3"
              style={{
                borderBottom: '2px solid #8382A8',
                textAlign: 'center',
                paddingBottom: 35,
                fontWeight: 'bold',
                color: '#5B59A9',
                margin: '0 40px',
              }}>
              Get started!
            </Typography>

            <div className={classes.whitePaper}>
              <Button
                className={classes.newWallet}
                variant="contained"
                onClick={() => history.push('/create-wallet')}>
                Create a New Wallet
                <KeyboardArrowRightIcon />
              </Button>
            </div>
            <div className={classes.whitePaper}>
              <Button
                className={classes.accessWallet}
                variant="contained"
                onClick={() => history.push('/access-wallet')}>
                Access My Wallet <KeyboardArrowRightIcon />
              </Button>
            </div>
          </Grid>
          <Grid item md={7} xs={12} style={{textAlign: 'center'}}>
            <img src={walletBenefit} className={classes.walletBenefit} />
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
}
